import { Directive, Input, OnInit, Renderer2, ViewContainerRef } from '@angular/core';
import { Log } from '@s8l/client-tree-lib';

import { BarChartFilteredWidgetComponent } from './bar-chart-filtered-widget/bar-chart-filtered-widget.component';
import { BarChartWidgetComponent } from './bar-chart-widget/bar-chart-widget.component';
import { LineGraphWidgetComponent } from './line-graph-widget/line-graph-widget.component';
import { MultiTableWidgetComponent } from './multi-table-widget/multi-table-widget.component';
import { TableWidgetComponent } from './table-widget/table-widget.component';
import { TotalActiveTimeWidgetComponent } from './total-active-time-widget/total-active-time-widget.component';
import { TransitionGraphWidgetComponent } from './transition-graph-widget/transition-graph-widget.component';
import { UsersPeakDateWidgetComponent } from './users-peak-date-widget/users-peak-date-widget.component';
import { UsersPeakWidgetComponent } from './users-peak-widget/users-peak-widget.component';
import { UsersWidgetComponent } from './users-widget/users-widget.component';

export const WidgetsComponentMap = {
  users: UsersWidgetComponent,
  usersPeak: UsersPeakWidgetComponent,
  usersPeakDate: UsersPeakDateWidgetComponent,
  totalActiveTime: TotalActiveTimeWidgetComponent,
  lineGraph: LineGraphWidgetComponent,
  barChart: BarChartWidgetComponent,
  barChartFiltered: BarChartFilteredWidgetComponent,
  multiTable: MultiTableWidgetComponent,
  table: TableWidgetComponent,
  transitionGraph: TransitionGraphWidgetComponent
};

@Directive({
  selector: '[homeWidget]'
})
export class HomeWidgetDirective implements OnInit {
  @Input() set component(component) {
    setTimeout(() => {
      this.createComponent(component);
    });
  }

  @Input() public column = null;
  @Input() public settings = {};
  @Input() public keyDate: Date;

  public componentRef = null;
  private componentType = null;

  constructor(private vcr: ViewContainerRef, private rend: Renderer2) {}

  public ngOnInit(): void {
    if (this.componentType) {
      this.componentRef.injector.get(this.componentType).ngOnInit();
    }
  }

  private createComponent(type: string): void {
    this.vcr.clear();
    this.componentType = WidgetsComponentMap[type];
    if (!this.componentType) {
      Log.error('Component not registered for type "' + type + '"');
      return;
    }
    this.componentRef = this.vcr.createComponent(this.componentType);
    this.rend.appendChild(this.vcr.element.nativeElement, this.componentRef.injector.get(this.componentType).elRef.nativeElement);
    this.componentRef.injector.get(this.componentType).homeWidgetDirective = this;
  }
}
